


























import Vue from "vue";
import getActivityColor from "@/views/app/activities/get-activity-color";

export default Vue.extend({
  name: 'ActivityToaster',
  data () {
    return {
      activity: false,
      snackbar: false,
      text: ''
    }
  },
  sockets: {
    new_activity: function (val) {
      this.$data.snackbar = true
      this.$data.activity = val
    }
  },
  methods: {
    getColor: getActivityColor
  },
})
